// Per-report selectors — components read from these and stay out of the store
// shape. Same pattern as containers/dashboard/selectors.js.

const empty = { data: null, loading: false, error: null, fieldErrors: null };

const slice = (state, key) => state?.reportsReducer?.[key] || empty;

export const selectClientAnalysis = (state) => slice(state, "clientAnalysis");
export const selectRevenueAnalysis = (state) => slice(state, "revenueAnalysis");
export const selectTransactionAnalysis = (state) => slice(state, "transactionAnalysis");
export const selectUserStats = (state) => slice(state, "userStats");
export const selectSalaryRevenueAnalysis = (state) => slice(state, "salaryRevenueAnalysis");
export const selectCompanyAnalysis = (state) => slice(state, "companyAnalysis");

// Convenience: pick the slice by the URL endpoint segment the operator has
// selected in the UI. Keeps the component from having to switch on strings.
const ENDPOINT_TO_SELECTOR = {
  clientanalysis: selectClientAnalysis,
  revenueanalysis: selectRevenueAnalysis,
  transactionanalysis: selectTransactionAnalysis,
  userstats: selectUserStats,
  salaryrevenueanalysis: selectSalaryRevenueAnalysis,
  companyanalysis: selectCompanyAnalysis,
};

export const selectAnalysisForEndpoint = (endpoint) => (state) => {
  const sel = ENDPOINT_TO_SELECTOR[endpoint];
  return sel ? sel(state) : empty;
};
